import '../sass/faqs.scss';

(() => {
    const detailsScript = document.querySelector('#blenheim-schools-details-js');
    const $blocks = document.querySelectorAll('.block.faqs');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $faqs = $block.querySelectorAll('.faqs__faq');

        const initFaqs = () => {
            if (!$faqs.length) return;

            const instances = [];

            $faqs.forEach($faq => {
                instances.push({
                    el: $faq,
                    instance: new Details($faq),
                });
            });

            $block.addEventListener('detailsopen', (e) => {
                instances.forEach(({ el, instance }) => {
                    if (el !== e.target && el.open) {
                        instance.close();
                    }
                });
            });
        };

        if (typeof Details !== 'undefined') {
            initFaqs();
        } else if (detailsScript) {
            detailsScript.addEventListener('load', () => {
                initFaqs();
            });
        } else {
            window.addEventListener('load', () => {
                const detailsScript = document.querySelector('#blenheim-schools-details-js');

                if (!detailsScript) return;

                initFaqs();
            });
        }
    });
})();
